import isEqual from 'lodash/isEqual';
import { ValidationDescriptor } from './types';

export const isAllowedValue = (
  validator: Pick<ValidationDescriptor<any>, 'value' | 'allowedValues'>
) => {
  const { value, allowedValues } = validator;
  if (!allowedValues) {
    return false;
  }
  return allowedValues.some(allowedValue => isEqual(value, allowedValue));
};
